import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const N = { navy:'#20396B', bubblegum:'#F2A7C0', blush:'#FBDDE6', cream:'#FCF6EC', sunny:'#FFC84B', teal:'#36B7A6', tealLight:'#d0f0ec', white:'#fff' };

export default function StudentPortal({ studentId, studentName, onLogout, onJoinSession }) {
  const [tab, setTab] = useState('home');
  const [weeklyUpdate, setWeeklyUpdate] = useState(null);
  const [materials, setMaterials] = useState([]);
  const [postits, setPostits] = useState([]);
  const [newNote, setNewNote] = useState('');
  const [liveSession, setLiveSession] = useState(null);

  useEffect(() => {
    fetchWeeklyUpdate(); fetchMaterials(); fetchPostits(); checkLiveSession();
    const ch = supabase.channel('session-watch-student')
      .on('postgres_changes', { event:'*', schema:'public', table:'live_sessions', filter:`student_id=eq.${studentId}` }, () => checkLiveSession())
      .subscribe();
    return () => supabase.removeChannel(ch);
  }, [studentId]);

  const fetchWeeklyUpdate = async () => { const { data } = await supabase.from('weekly_updates').select('*').eq('student_id', studentId).order('created_at',{ascending:false}).limit(1).single(); setWeeklyUpdate(data); };
  const fetchMaterials = async () => { const { data } = await supabase.from('materials').select('*').eq('student_id', studentId).order('created_at',{ascending:false}); setMaterials(data||[]); };
  const fetchPostits = async () => { const { data } = await supabase.from('postits').select('*').eq('student_id', studentId).order('created_at',{ascending:false}); setPostits(data||[]); };
  const checkLiveSession = async () => { const { data } = await supabase.from('live_sessions').select('*').eq('student_id', studentId).eq('active', true).single(); setLiveSession(data); };
  const addPostit = async () => { if (!newNote.trim()) return; await supabase.from('postits').insert([{ student_id: studentId, content: newNote.trim(), author:'student' }]); setNewNote(''); fetchPostits(); };
  const deletePostit = async (id) => { await supabase.from('postits').delete().eq('id', id); fetchPostits(); };

  const postitCols = [N.sunny+'88', N.bubblegum+'88', N.tealLight, N.blush, '#e8edf5'];
  const card = (bg) => ({ background:bg||N.white, borderRadius:16, padding:'18px 20px', boxShadow:'0 2px 10px rgba(32,57,107,0.07)', marginBottom:14 });
  const tabs = [['home','🏠 Home'],['materials','📁 Materials'],['postits','📝 Notes']];

  return (
    <div style={{ minHeight:'100vh', background:N.cream, display:'flex', flexDirection:'column' }}>
      <div style={{ background:N.navy, padding:'12px 24px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <span style={{ fontSize:22 }}>🐰</span>
          <div>
            <div style={{ fontFamily:'var(--font-head)', fontSize:17, fontWeight:700, color:'#fff' }}>OkieDokie Academy</div>
            <div style={{ fontSize:12, color:N.bubblegum, fontWeight:700 }}>Hi, {studentName}! 🎉</div>
          </div>
        </div>
        <button onClick={onLogout} style={{ background:'rgba(255,255,255,0.15)', border:'none', borderRadius:10, padding:'7px 14px', cursor:'pointer', fontSize:12, color:'#fff', fontFamily:'var(--font-body)', fontWeight:600 }}>Log out</button>
      </div>

      <div style={{ display:'flex', background:N.white, borderBottom:`2px solid ${N.blush}`, padding:'0 24px' }}>
        {tabs.map(([key,label]) => (
          <button key={key} onClick={() => setTab(key)} style={{ padding:'11px 16px', border:'none', background:'none', cursor:'pointer', fontFamily:'var(--font-body)', fontSize:13, fontWeight: tab===key ? 700 : 600, color: tab===key ? N.navy : '#8a9ab8', borderBottom: tab===key ? `3px solid ${N.navy}` : '3px solid transparent', marginBottom:-2 }}>{label}</button>
        ))}
      </div>

      <div style={{ padding:'22px 24px', maxWidth:860, margin:'0 auto', width:'100%' }}>

        {tab === 'home' && (
          <>
            {liveSession && (
              <div style={{ ...card(N.navy), border:`2px solid ${N.teal}` }}>
                <div style={{ fontFamily:'var(--font-head)', fontSize:17, fontWeight:700, color:'#fff' }}>🔴 Your lesson is live!</div>
                <div style={{ fontSize:13, color:N.bubblegum, marginTop:4 }}>Your tutor has started today's lesson. Jump in now!</div>
                <button onClick={() => onJoinSession && onJoinSession(liveSession)} style={{ background:N.teal, color:'#fff', border:'none', borderRadius:12, padding:'11px 24px', fontSize:15, cursor:'pointer', fontFamily:'var(--font-body)', fontWeight:700, marginTop:12, boxShadow:'0 4px 12px #36B7A655' }}>
                  Join Lesson 🚀
                </button>
              </div>
            )}

            <div style={card(N.blush)}>
              <div style={{ fontFamily:'var(--font-head)', fontSize:16, fontWeight:700, color:N.navy, marginBottom:10 }}>📋 Today's Lesson</div>
              {weeklyUpdate?.lesson_goals ? (
                <div style={{ fontSize:14, lineHeight:1.8, whiteSpace:'pre-wrap', color:N.navy }}>{weeklyUpdate.lesson_goals}</div>
              ) : (
                <div style={{ color:'#8a9ab8', fontSize:13 }}>Nothing posted yet — check back soon!</div>
              )}
            </div>

            <div style={card(N.tealLight)}>
              <div style={{ fontFamily:'var(--font-head)', fontSize:16, fontWeight:700, color:N.navy, marginBottom:10 }}>✏️ This Week's Homework</div>
              {weeklyUpdate?.homework ? (
                <div style={{ fontSize:14, lineHeight:1.8, whiteSpace:'pre-wrap', color:N.navy }}>{weeklyUpdate.homework}</div>
              ) : (
                <div style={{ color:'#8a9ab8', fontSize:13 }}>No homework posted yet!</div>
              )}
            </div>
          </>
        )}

        {tab === 'materials' && (
          <div style={card()}>
            <div style={{ fontFamily:'var(--font-head)', fontSize:16, fontWeight:700, color:N.navy, marginBottom:12 }}>Your Materials</div>
            {materials.length === 0 && <div style={{ color:'#8a9ab8', fontSize:13 }}>Your tutor will upload files here before or during your lesson.</div>}
            {materials.map(mat => (
              <div key={mat.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 0', borderBottom:`1px solid ${N.blush}` }}>
                <span style={{ fontSize:20 }}>📄</span>
                <a href={mat.file_url} target="_blank" rel="noreferrer" style={{ color:N.teal, fontSize:14, textDecoration:'none', fontWeight:700 }}>{mat.file_name}</a>
              </div>
            ))}
          </div>
        )}

        {tab === 'postits' && (
          <>
            <div style={{ ...card(N.sunny+'55'), border:`2px solid ${N.sunny}` }}>
              <div style={{ fontFamily:'var(--font-head)', fontSize:15, fontWeight:700, color:N.navy, marginBottom:8 }}>Add a note 📌</div>
              <textarea value={newNote} onChange={e => setNewNote(e.target.value)}
                style={{ width:'100%', padding:'10px 12px', borderRadius:10, border:`2px solid ${N.sunny}`, fontSize:14, fontFamily:'var(--font-body)', outline:'none', minHeight:70, resize:'none', background:'#fff' }}
                placeholder="Write something you want to remember..." spellCheck={false} autoCorrect="off" />
              <br />
              <button onClick={addPostit} style={{ background:N.sunny, color:N.navy, border:'none', borderRadius:10, padding:'8px 18px', fontSize:13, cursor:'pointer', fontFamily:'var(--font-body)', fontWeight:700, marginTop:8 }}>Stick it! 📌</button>
            </div>
            <div style={{ fontFamily:'var(--font-head)', fontSize:15, fontWeight:700, color:N.navy, marginBottom:10 }}>Our Notes Board</div>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(155px,1fr))', gap:12 }}>
              {postits.map((p, i) => (
                <div key={p.id} style={{ background:postitCols[i%postitCols.length], borderRadius:14, padding:'12px', minHeight:88, boxShadow:'0 2px 8px rgba(32,57,107,0.08)', position:'relative', fontSize:13 }}>
                  <button onClick={() => deletePostit(p.id)} style={{ position:'absolute', top:5, right:8, background:'none', border:'none', cursor:'pointer', fontSize:16, color:'#aaa' }}>×</button>
                  <div style={{ fontSize:11, color:'#8a9ab8', marginBottom:4, fontWeight:600 }}>{p.author==='tutor'?'👩‍🏫 Tutor':'👧 Me'}</div>
                  <div style={{ whiteSpace:'pre-wrap', color:N.navy }}>{p.content}</div>
                </div>
              ))}
              {postits.length === 0 && <div style={{ color:'#8a9ab8', fontSize:13 }}>No notes yet. Add one above!</div>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
